<script setup>
const RankingInfo = ref([])

onMounted(() => {
  getTodo()
})

const getTodo = () => {
  getRankingData().then((RankingData) => {
    RankingInfo.value = RankingData.sgtk_menu
  }).catch((e) => {
    console.log(e)
  })
}

const getRankingData = async () => {
  const api = `https://dcsgtk.wni.co.jp/s/json/sgtk_menu.json`
  const retInfo = await getJsonData(api)
  return retInfo
}
</script>

<template>
  <ul id="menu_ranking">
    <a
      v-for="(data, ind) in RankingInfo.slice(0, 5)"
      :key="ind"
      :href="data.link"
    >
      <li>
        <div :class="'rank rankNo' + (ind +1)" />
        <div class="rankImg"><img
          :src="`${data.img}`"
          loading="lazy"
        ></div>
        <div class="rankTxt"><span class="subject">{{ data.title }}</span>
          <br><span class="description">{{ data.detail }}</span></div>
      </li>
    </a>
  </ul>
</template>

<style scoped>
.rankImg{
  width:40px;
  margin:0 10px;
}
.rankImg img{
  width:40px;
}
.rankTxt{
  line-height: 1.5em;
}

#menu_ranking {
  font-size:15px;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  max-width: 800px;
}

#menu_ranking li{
  border-bottom: 1px solid #D0D0D0;
  padding:8px;
  display: flex;
}
#menu_ranking li div{
  display: inline;
  height: auto;
}
ul#menu_ranking li .subject{
  padding: 7px 0;
  font-weight:bold;
  color:#4c4c4c;
}
ul#menu_ranking li .description{
  color:#4c4c4c;
}

ul#menu_ranking li .rank {
  font-weight: bold;
  padding: 8px 0 0 10px;
  color: #fff;
  font-size: 13px;
  display: inline-block;
  width: 35px;
}

ul#menu_ranking li .rankNo1{
  background:url(https://dcsgtk.wni.co.jp/s/images/icon/star-icon/rank1.png) no-repeat;
  background-size: 32px;
}
ul#menu_ranking li .rankNo2{
  background:url(https://dcsgtk.wni.co.jp/s/images/icon/star-icon/rank2.png) no-repeat;
  background-size: 32px;
}
ul#menu_ranking li .rankNo3{
  background:url(https://dcsgtk.wni.co.jp/s/images/icon/star-icon/rank3.png) no-repeat;
  background-size: 32px;
}
ul#menu_ranking li .rankNo4{
  background:url(https://dcsgtk.wni.co.jp/s/images/icon/star-icon/rank4.png) no-repeat;
  background-size: 27px;
  margin-top: 3px;
}
ul#menu_ranking li .rankNo5{
  background:url(https://dcsgtk.wni.co.jp/s/images/icon/star-icon/rank5.png) no-repeat;
  background-size: 27px;
  margin-top: 3px;
}

ul#menu_ranking li .rankNo1,
ul#menu_ranking li .rankNo2,
ul#menu_ranking li .rankNo3{
  background-position-y: 2px;
}
</style>
